// import env from './env';
import sensors from 'sa-sdk-javascript';

export function GioTrack(
  eventId: string,
  eventLevelVariables: { [k: string]: string }
) {
  // if (typeof window.gio !== 'function') {
  //   return;
  // }

  // const isProd = env.appEnv === 'prod';
  // // 处理eventId，区分测试环境
  // const parseEventId = () => {
  //   if (isProd) {
  //     return eventId;
  //   }

  //   // 兼容已经添加的-qa的事件
  //   return eventId.indexOf('_qa') !== -1 ? eventId : `${eventId}_qa`;
  // };

  // window.gio('track', parseEventId(), eventLevelVariables);

  /**
   * 神策测试和线上事件名一直，都不要_qa后缀
   */
  sensors.track(
    'medlinker_' + eventId.replace(/_qa$/, ''),
    eventLevelVariables
  );
}

/**
 * 模拟gio
 * @param action 'track' | 'people.set'
 * @param eventId string
 * @param eventLevelVariables Object
 */
export function simulationGio(
  action: 'track' | 'people.set',
  eventId: string,
  eventLevelVariables: { [k: string]: string }
) {
  if (action === 'track') {
    GioTrack(eventId, eventLevelVariables);
  } else if (action === 'people.set') {
    sensors.setProfile(eventLevelVariables);
  }
}

/**
 * 商城页面使用了med-template组件，该组件直接用了window.gio()上报数据
 */
// @ts-ignore
window.gio = simulationGio;
